import React from 'react';
import { string, array } from 'prop-types';
import { Breadcrumbs } from '@fiverr-private/fit';
import { createSanitizedMarkup } from '@fiverr-private/futile';

import { convertSlugToText } from '../../../../../utils/common';
import { PAGE_TYPE_CONFIG } from '../../../../../utils/pageTypesConfig';
import { calculateLinkAddress } from './utils';
import classes from './styles.module.scss';

const GeneratedBreadcrumbs = ({ pageType, pathHierarchy, pageUrl }) => {
    const breadcrumbsConfig = PAGE_TYPE_CONFIG[pageType].breadcrumbs;
    const renderNavigationalBreadcrumb = pathHierarchy.length > 1;

    let scriptJson;
    if (breadcrumbsConfig.includeSeoScript) {
        scriptJson = {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            'itemListElement': []
        };
    }

    const breadcrumbs = [];
    let schemaLinkAddress, navigationalLinkAddress, pageTitle;
    for (const [index, value] of pathHierarchy.entries()) {
        pageTitle = convertSlugToText(value);

        if (breadcrumbsConfig.includeSeoScript) {
            schemaLinkAddress = calculateLinkAddress(pageType, pathHierarchy, index);
            scriptJson.itemListElement.push({
                '@type': 'ListItem',
                'position': index + 1,
                'name': pageTitle,
                'item': `${new URL(pageUrl).origin}${schemaLinkAddress}`
            });
        }

        navigationalLinkAddress = calculateLinkAddress(pageType, pathHierarchy, index);

        breadcrumbs.push(
            <Breadcrumbs.Crumb key={pageTitle}>
                <a href={navigationalLinkAddress}>{pageTitle.toUpperCase()}</a>
            </Breadcrumbs.Crumb>);
    }

    return (
        <div>
            <script type="application/ld+json" dangerouslySetInnerHTML={createSanitizedMarkup(JSON.stringify(scriptJson))}/>
            {renderNavigationalBreadcrumb && <Breadcrumbs className={classes.contentLandingPagesBreadcrumbs}>
                {breadcrumbs}
            </Breadcrumbs> }
        </div>
    );
};

GeneratedBreadcrumbs.propTypes = {
    pathHierarchy: array,
    pageType: string
};

export default GeneratedBreadcrumbs;
